class UpsellsBanner extends HTMLElement {
  constructor() {
    super();
    this.apiBaseUrl = window.theme.internalApp.baseUrl;
    this.isCurrentlyFetching = false;
    this.lastVariantId = null;
  }

  connectedCallback() {
    this.fetchUpsellData();

    this.setupOptionChangeListeners();
  }

  getCurrentVariantId() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantFromUrl = urlParams.get('variant');

    if (variantFromUrl) {
      return variantFromUrl;
    }

    const variantSelect = document.querySelector('form[action="/cart/add"] select[name="id"]');

    if (variantSelect?.value) {
      return variantSelect.value;
    }

    const productForm = document.querySelector('product-form.product-info-detail');

    if (productForm?.dataset?.variantId) {
      return productForm.dataset.variantId;
    }

    return null;
  }

  async fetchUpsellData() {
    try {
      const variantId = this.getCurrentVariantId();

      if (!variantId) {
        return;
      }

      if (variantId === this.lastVariantId && this.isCurrentlyFetching) {
        return;
      }

      this.isCurrentlyFetching = true;
      this.lastVariantId = variantId;

      this.classList.remove('upsells-banner--visible');
      this.innerHTML = '';

      const apiUrl = `${this.apiBaseUrl}/upsells?variantId=${variantId}`;

      const response = await fetch(apiUrl);
      //TODO: REMEMBER DELETE FILTER JD-NEXT
      let data = await response.json();

      if (Array.isArray(data)) {
        data = data.filter(item => item.storeUrl && item.storeUrl.includes('jdnext'));
      } else if (data && typeof data === 'object') {
        data = data.storeUrl && data.storeUrl.includes('jdnext') ? [data] : [];
      }

      //TODO: REMEMBER DELETE FILTER JD-NEXT

      if (data && Array.isArray(data) && data.length > 0) {
        this.renderUpsells(data);
      } else if (data && !Array.isArray(data) && Object.keys(data).length > 0) {
        this.renderUpsells([data]);
      } else {
        // No upsells found, remove the CSS styles
        this.removeProductVariantsContainerStyles();
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.isCurrentlyFetching = false;
    }
  }

  renderUpsells(items) {
    if (!items || !Array.isArray(items) || items.length === 0) {
      return;
    }

    // Apply CSS for product variants container when upsells are present
    this.applyProductVariantsContainerStyles();

    items.forEach(item => {
      if (!item) {
        return;
      }

      let description = '';

      if (item.description && item.description.length) {
        description = `<p class='upsell-banner__description'>${item.description || ''}</p>`;
      }

      let link = '';

      if (item.storeUrl && item.storeUrl.length) {
        link = `<a href='${item.storeUrl || '#'}' class='upsell-banner__link' target='_blank' rel='noopener noreferrer'>Read More</a>`;
      }

      const bannerHTML = `
        <div class='upsell-banner'>
          <div class='upsell-banner__bg-pattern'></div>
          <div class='upsell-banner__content'>
            <div class='upsell-banner__logo'>
              <img src='${item.imageUrl || ''}' alt='${item.title || ''}' loading='lazy' width='450' height='300'>
            </div>

            <div class='upsell-banner__details'>
              <h3 class='upsell-banner__headline'>${item.title || ''}</h3>
              ${description}
              ${link}
            </div>
          </div>
        </div>
      `;

      this.insertAdjacentHTML('beforeend', bannerHTML);
    });

    this.classList.add('upsells-banner--visible');
  }

  applyProductVariantsContainerStyles() {
    // Create or update the style element for product variants container
    let styleElement = document.getElementById('upsells-product-variants-styles');

    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = 'upsells-product-variants-styles';
      document.head.appendChild(styleElement);
    }

    const css = `
      @media (min-width: 992px) {
        .product-variants-container {
          position: relative;
        }
      }
    `;

    styleElement.textContent = css;
  }

  removeProductVariantsContainerStyles() {
    // Remove the style element for product variants container
    const styleElement = document.getElementById('upsells-product-variants-styles');

    if (styleElement) {
      styleElement.remove();
    }
  }

  setupOptionChangeListeners() {
    const productFormOptions = document.querySelectorAll('product-form input[name^="option"][type="radio"]');

    productFormOptions.forEach(selector => {
      selector.addEventListener('change', () => {
        setTimeout(() => {
          this.fetchUpsellData();
        }, 200);
      });
    });

    const variantSelectors = [
      ...document.querySelectorAll('select[name^="option"]'),
      ...document.querySelectorAll('input[name^="option"][type="radio"]:not(product-form input)'),
    ];

    variantSelectors.forEach(selector => {
      selector.addEventListener('change', () => {
        this.fetchUpsellData();
      });
    });
  }
}

customElements.define('upsells-banner', UpsellsBanner);
